var Config = {
  LIMIT: 10,
  PERSIST_SECRET_KEY: "APP_REDUX_PERSIST_STORE_KEY",
  ENVIRONMENT: "DEVELOP",
  ENVIRONMENTS: {
    LOCAL: {
      API_URL: "https://api-aou.kodefuse.com/v1",
    },
    DEVELOP: {
      API_URL: "https://api-aou.kodefuse.com/v1",
    },
    STAGING: {
      API_URL: "https://api-aou-qa.kodefuse.com/v1",
    },
    PRODUCTION: {
      API_URL: "https://api.ageofuncertaintycoaching.com/v1",
    },
  },
};
Config.env = () => {
  return Config.ENVIRONMENTS[Config.ENVIRONMENT];
};
export default Config;
